import { Card, Row, Col } from 'react-bootstrap'
import { ISelectData } from '../../../ui/Selects/select/model'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  useCreateCourseMutation,
  useGetCourseByIdQuery,
  useUpdateCourseMutation
} from '../../../store/api/expert/Courses/courses'
import { TCoursePayload } from '../../../store/api/expert/Courses/model'
import { responseError, validationRequaired } from '../../../validation/validationRequaired'
import { toast } from 'react-toastify'
import { IValidationRequired } from '../../../validation/model'
import Loading from '../../Loading/Loading'
import SelectExpert from '../../../ui/Selects/SelectExpert/SelectExpert'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { EditorConfigurationInResourceText } from '../../../utils/constants'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

const initialData = {
  title: '',
  titleAr: '',
  author: '',
  authorAr: '',
  shortDescription: '',
  shortDescriptionAr: '',
  longDescription: '',
  longDescriptionAr: ''
}

const CoursesCreate = (): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const { t: tRequired } = useTranslation('required')
  const { id: courseId } = useParams()
  const navigate = useNavigate()
  const [createCourse] = useCreateCourseMutation()
  const [updateCourse] = useUpdateCourseMutation()
  const {
    isLoading,
    data: courseDataById,
    refetch
  } = useGetCourseByIdQuery(Number(courseId), { skip: !courseId })

  const [selectedExpert, setSelectedExpert] = useState<ISelectData>()
  const [sendToBeck, setSendToBeck] = useState<TCoursePayload>(initialData as TCoursePayload)
  const [errorRequired, setErrorRequired] = useState<IValidationRequired>({})

  const onChange = (name: string, value: string | File): void => {
    setSendToBeck(prev => ({ ...prev, [name]: value }))
  }

  const handleCreateCourse = async (): Promise<void> => {
    const { link, image, ...another } = sendToBeck

    const errors = validationRequaired({
      ...another,
      expertId: selectedExpert?.value
    })

    setErrorRequired(errors)
    if (Object.keys(errors).length > 0) {
      return
    }
    const newObj: TCoursePayload = {
      ...another,
      expertId: selectedExpert?.value,
      link,
      image
    }

    const res = courseId ? await updateCourse(newObj) : await createCourse(newObj)

    if ('error' in res) {
      responseError(res)
    } else {
      toast.success('Course created successfully!')
      navigate(-1)
    }
  }

  useEffect(() => {
    if (courseDataById) {
      setSendToBeck(courseDataById)
      if (Object.keys(courseDataById?.expert).length) {
        setSelectedExpert({
          label: courseDataById?.expert.name,
          value: courseDataById?.expert.id
        })
      }
    }
  }, [courseDataById])

  useEffect(() => {
    if (courseId) {
      refetch()
    }
  }, [courseId])

  return (
    <div>
      {courseId && isLoading ? <Loading /> : null}
      <Card.Header>
        <h2>
          {tGeneral(courseId ? 'edit' : 'create')} {tGeneral('course')}
        </h2>
      </Card.Header>
      <Row>
        <Col lg={12} xl={12} md={12} sm={12}>
          <Card>
            <Card.Body>
              <Row>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('title')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescription}
                    name='title'
                    className='form-control'
                    placeholder={tGeneral('title')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.title && (
                    <span className='text-danger'>{tRequired('title')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('titleAr')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescription}
                    name='titleAr'
                    dir='rtl'
                    className='form-control'
                    placeholder={tGeneral('titleAr')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.titleAr && (
                    <span className='text-danger'>{tRequired('titleAr')}</span>
                  )}
                </Col>

                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('author')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescription}
                    name='author'
                    className='form-control'
                    placeholder={tGeneral('author')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.author && (
                    <span className='text-danger'>{tRequired('author')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('authorAr')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescription}
                    name='authorAr'
                    dir='rtl'
                    className='form-control'
                    placeholder={tGeneral('authorAr')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.authorAr && (
                    <span className='text-danger'>{tRequired('authorAr')}</span>
                  )}
                </Col>

                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('short')} {tGeneral('description')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescription}
                    name='shortDescription'
                    className='form-control'
                    placeholder={`${tGeneral('short')} ${tGeneral('description')}`}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.shortDescription && (
                    <span className='text-danger'>{tRequired('shortDescription')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('short')} {tGeneral('descriptionAr')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.shortDescriptionAr}
                    name='shortDescriptionAr'
                    dir='rtl'
                    className='form-control'
                    placeholder={`${tGeneral('short')} ${tGeneral('descriptionAr')}`}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                  {errorRequired?.shortDescriptionAr && (
                    <span className='text-danger'>{tRequired('shortDescriptionAr')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark mt-5' htmlFor='exampleInputname'>
                    {tGeneral('long')} {tGeneral('description')}
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    config={EditorConfigurationInResourceText}
                    data={sendToBeck?.longDescription || ''}
                    id='text'
                    onChange={(_, editor) => onChange('longDescription', editor.getData())}
                  />
                  {errorRequired?.longDescription && (
                    <span className='text-danger'>{tRequired('longDescription')}</span>
                  )}
                </Col>
                <Col xs={6} md={6}>
                  <label className='text-dark mt-5' htmlFor='exampleInputname'>
                    {tGeneral('long')} {tGeneral('descriptionAr')}
                  </label>
                  <CKEditor
                    key={'rtl'}
                    editor={ClassicEditor}
                    config={{
                      ...EditorConfigurationInResourceText,
                      language: 'ar'
                    }}
                    data={sendToBeck?.longDescriptionAr || ''}
                    id='text'
                    onChange={(_, editor) => onChange('longDescriptionAr', editor.getData())}
                  />
                  {errorRequired?.longDescriptionAr && (
                    <span className='text-danger'>{tRequired('longDescriptionAr')}</span>
                  )}
                </Col>

                <Col xs={6} md={6}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('link')}
                  </label>
                  <input
                    type='text'
                    defaultValue={sendToBeck?.link}
                    name='link'
                    className='form-control'
                    placeholder={tGeneral('link')}
                    onChange={({ target }) => onChange(target.name, target.value)}
                  />
                </Col>
                <Col
                  xs={6}
                  md={7}
                  style={courseId && selectedExpert?.value ? { opacity: 0.5 } : {}}
                >
                  <SelectExpert
                    selected={selectedExpert}
                    setSelected={setSelectedExpert}
                    isDisabled={Boolean(courseId && selectedExpert?.value)}
                  />
                  {errorRequired?.expertId && (
                    <span className='text-danger'>{tRequired('expertId')}</span>
                  )}
                </Col>
                <Col xs={6} md={7}>
                  <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                    {tGeneral('file')}
                  </label>
                  <input
                    defaultValue={sendToBeck?.image}
                    type='file'
                    name='image'
                    className='form-control'
                    accept='image/*'
                    onChange={({ target }) => onChange(target.name, target.files[0])}
                  />
                  {sendToBeck?.image && (
                    <div className='avatar avatar-lg  brround cover-image bg-primary mr-10'>
                      <img
                        style={{ width: '200px' }}
                        src={sendToBeck?.image}
                        className='avatar avatar-lg  brround cover-image bg-primary object-fit-contain'
                        alt=''
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className='text-end'>
              <button className='btn btn-success mt-1 me-2' onClick={() => handleCreateCourse()}>
                {tGeneral('save')}
              </button>
              <button
                type='button'
                className='btn btn-danger mt-1 me-2'
                onClick={() => navigate(-1)}
              >
                {tGeneral('cancel')}
              </button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default CoursesCreate
